import { Col, Container, Row } from "react-bootstrap";
import "react-multi-carousel/lib/styles.css";
import colorSharp from "../assets/img/color-sharp.png";
import cbw from "../assets/img/cbw.png";
import btech from "../assets/img/btech.png";
import rtImg from "../assets/img/realtruck.png";

export const About = () => {
  return (
    <section className="about" id="about">
      <Container>
        <Row>
          <Col>
            <div className="about-card">
              <div className="heading">
                <h3 className="tagline">Experience</h3>
              </div>
              <Row>
                <div className="work-history">
                  <div className="work-history-item">
                    <a
                      href="https://realtruck.com/builder"
                      target="_blank"
                      rel="noreferrer"
                    >
                      <img
                        src={rtImg}
                        alt="RealTruck LLC"
                        style={{ width: "283px", height: "69px" }}
                      />
                    </a>
                    <p>
                      3D Builder - Assoc. Developer,
                      <i> Nov. 2024 - Present</i>
                    </p>
                  </div>
                  <div className="work-history-item">
                    <a
                      href="https://controlbyweb.com/"
                      target="_blank"
                      rel="noreferrer"
                    >
                      <img
                        src={cbw}
                        alt="ControlByWeb LLC"
                        style={{ width: "222px", height: "80px" }}
                      />
                    </a>
                    <p>
                      Web Developer
                      <br />
                      <i> 1yr 4 mos</i>
                    </p>
                  </div>
                  <div className="work-history-item">
                    <a
                      href="https://btech.edu/software-development/"
                      target="_blank"
                      rel="noreferrer"
                    >
                      <img
                        src={btech}
                        alt="Bridgerland Technical College"
                        style={{ width: "290px", height: "80px" }}
                      />
                    </a>
                    <p>
                      Software Development Instructor,<i> 4 mos</i>
                    </p>
                  </div>
                </div>
              </Row>
            </div>
            <div className="about-card">
              <div className="heading">
                <h3 className="tagline">Skillset</h3>
              </div>
              <div className="skills">
                <img
                  alt="Engineering skills: full-stack & web graphics"
                  src="https://skillicons.dev/icons?i=ts,react,html,css,sass,tailwind,nodejs,python,cpp,php,mysql,mongodb,aws,gcp,linux,git,vite,docker,blender,godot,threejs&perline=6"
                />
              </div>
            </div>
          </Col>
        </Row>
      </Container>
      <img className="background-image-left" src={colorSharp} alt="" />
    </section>
  );
};
